// extracted by mini-css-extract-plugin
module.exports = {"Button":"Video_Button__1J4sw","Caption":"Video_Caption__2T9mA"};